module.exports = __webpack_public_path__ + "static/img/2017-04-08 11.10.48.d3f6832.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cabins/main/2017-04-08 11.10.48.jpg
// module id = lAg8
// module chunks = 4